<template>
  <span class="mbo-hero">
    <img v-if="hero && hero.avatar && !broken" :src="hero.avatar" alt="" @error="broken = true">
    <span v-else class="mbo-hero__ph">{{ initials }}</span>
  </span>
</template>

<script>
// Иконка героя на эфире: картинка из справочника или заглушка (героя нет в справочнике → «#»)
export default {
  name: 'MbOverlayHero',
  props: {
    hero: {type: Object, default: null},
  },
  data() {
    return {broken: false}
  },
  computed: {
    initials() {
      if (!this.hero) return ''
      if (!this.hero.known) return '#'
      return this.hero.name.split(/[\s-]+/).map((w) => w[0]).join('').slice(0, 2).toUpperCase()
    },
  },
  watch: {
    'hero.avatar'() {
      this.broken = false
    },
  },
}
</script>
